import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface IframeModalProps {
  url: string;
  title: string;
  onClose: () => void;
}
export function IframeModal({
  url,
  title,
  onClose
}: IframeModalProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [onClose]);
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" role="dialog" aria-modal="true" aria-label={title} data-id="element-36">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-37" />
      <div className="relative w-full max-w-4xl h-[85vh] bg-white rounded-xl shadow-2xl flex flex-col overflow-hidden z-10" data-id="element-38">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 bg-white" data-id="element-39">
          <h2 className="text-base font-semibold text-[#333333]" data-id="element-40">{title}</h2>
          <button onClick={onClose} className="p-1.5 rounded-lg text-[#555555] hover:text-[#CC0000] hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-[#CC0000]" aria-label="Cerrar" data-id="element-41">
            <XIcon className="w-5 h-5" data-id="element-42" />
          </button>
        </div>
        <iframe src={url} title={title} className="flex-grow w-full border-0" sandbox="allow-scripts allow-same-origin" data-id="element-43" />
      </div>
    </div>;
}